/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const findCandidateByEmailDataSchema = z.object({
	email: z.string().email(),
	organisationId: z.string().uuid(),
})

export type FindCandidateByEmailDataSchema = z.infer<typeof findCandidateByEmailDataSchema>
